 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALFTITLE from '@/components/halftitle'
 import DEDICATION from '@/components/dedication'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import OTHER from '@/components/other'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import ACK from '@/components/ack'
 import FOREWORD from '@/components/foreword'
 import PREFACE from '@/components/preface'
 import INT from '@/components/int'
 import PART01 from '@/components/part01'
 import CH01 from '@/components/ch01'
 import CH01A from '@/components/ch01a'
 import CH02 from '@/components/ch02'
 import CH02A from '@/components/ch02a'
 import CH03 from '@/components/ch03'
 import CH03A from '@/components/ch03a'
 import CH04 from '@/components/ch04'
 import CH04A from '@/components/ch04a'
 import CH05 from '@/components/ch05'
 import CH05A from '@/components/ch05a'
 import PART02 from '@/components/part02'
 import CH06 from '@/components/ch06'
 import CH07 from '@/components/ch07'
 import CH08 from '@/components/ch08'
 import CH09 from '@/components/ch09'
 import CH10 from '@/components/ch10'
 import PART03 from '@/components/part03'
 import CH11 from '@/components/ch11'
 import CH12 from '@/components/ch12'
 import LOVE_2 from '@/components/love_2'
 import AFTERWORD from '@/components/afterword'
 import APPENDIX from '@/components/appendix'
 import APPENDIX01 from '@/components/appendix01'
 import APPENDIX02 from '@/components/appendix02'
 import APPENDIX03 from '@/components/appendix03'
 import APPENDIX04 from '@/components/appendix04'
 import RESOURCES from '@/components/resources'
 import INDEX from '@/components/index'
 import NOTES from '@/components/notes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/preface",
 			"name" : "preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/int",
 			"name" : "int",
 			"component" : INT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js